"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ethereum_block_by_date_1 = __importDefault(require("ethereum-block-by-date"));
// BlockDater.getDate() recursively calls itself until it finds the block number. Depending on the parameters
// this may cause a call stack size error. ORUs with short block times may be more susceptible to this.
// Retrying is necessary to avoid this error until a better solution is implemented.
function getBlockNumberFromDate(provider, date) {
    return __awaiter(this, void 0, void 0, function* () {
        const blockDater = new ethereum_block_by_date_1.default(provider);
        let retryCount = 0;
        let info;
        while (true) {
            try {
                info = yield blockDater.getDate(date);
                if (!info) {
                    throw new Error('could not retrieve block number');
                }
            }
            catch (err) {
                retryCount++;
                console.log(`getBlockNumberFromDate: retrying ${retryCount}`);
                if (retryCount < 5)
                    continue;
                break;
            }
            break;
        }
        if (!info) {
            throw new Error('could not retrieve block number');
        }
        return info.block;
    });
}
exports.default = getBlockNumberFromDate;
